import {useState, useEffect} from 'react';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {useMediaQuery} from '@mui/material';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import useFindPath from '../../Helpers/useFindPath';
import Stepper from '../../components/Stepper';
import {
  ATDDropzone,
  DocumentationDropzone,
  FinanceDropzone,
  PengesyoranBajaDropzone,
} from '../../components';
import MyDropzone from '../../components/Dropzone';
import PageNav from '../../components/PageNav';
import '../../assets/styles/uploadPage.scss';

import macWP from '../../assets/images/macWP.jpg';
import mapUpload from '../../assets/images/mapUpload.png';
import lintraDocs from '../../assets/images/lintraDocs.png';
import docsReport from '../../assets/images/docsReport.png';
import bgIot from '../../assets/images/Upload-IoT-Event-Data.jpg';
import {
  UploadATDBg,
  UploadKewanganBg,
  UploadPesertaLotBg,
  UploadPengesyoranBg,
  UploadPPPLSBg,
  UploadDocumentationBg,
} from '../../assets';
import {Language} from '../../context/LanguageContext';

const UploadPage = ({totalSteps = 3}) => {
  const theme = createTheme({
    typography: {
      fontFamily: ['Montserrat'],
    },
  });
  const {language, newObj} = Language();
  const [title, setTitle] = useState(null);
  const [imageSelected, setImageSelected] = useState(null);
  const [bgSize, setBgSize] = useState(null);
  const [steps, setSteps] = useState(0);
  const path = useFindPath();

  useEffect(() => {
    if (path.currentPath === '/uploadmap') {
      setTitle(newObj.UploadMapWord[language]);
      setImageSelected(mapUpload);
      setBgSize('cover');
    } else if (path.currentPath === '/uploadreport') {
      setTitle(newObj.UploadDocumentReportWord[language]);
      setImageSelected(docsReport);
      setBgSize('contain');
    } else if (path.currentPath === '/uploadpalm') {
      setTitle(newObj.UploadPalmOilDataWord[language]);
      setBgSize('contain');
      setImageSelected(lintraDocs);
    } else if (path.currentPath === '/uploadpaddy') {
      setTitle(newObj.UploadPaddyDataWord[language]);
      setImageSelected(lintraDocs);
      setBgSize('contain');
    } else if (path.currentPath === '/uploadrubber') {
      setTitle(newObj.UploadRubberDataWord[language]);
      setImageSelected(lintraDocs);
      setBgSize('contain');
    } else if (path.currentPath === '/uploadiotevent') {
      setImageSelected(bgIot);
      setBgSize('cover');
      setTitle(newObj.UploadIoTEventDataWord[language]);
    } else if (path.currentPath === '/upload-pppls') {
      setTitle(newObj.PPPLSDataWord[language]);
      setImageSelected(UploadPPPLSBg);
      setBgSize('cover');
    } else if (path.currentPath === '/upload-participants-and-lot') {
      setTitle(newObj.ParticipantsAndLotWord[language]);
      setImageSelected(UploadPesertaLotBg);
      setBgSize('cover');
    } else if (path.currentPath === '/upload-pengesyoran-baja') {
      setTitle(newObj.FertilizerTrackingWord[language]);
      setImageSelected(UploadPengesyoranBg);
      setBgSize('cover');
    } else if (path.currentPath === '/upload-atd') {
      setTitle(newObj.ATDWord[language]);
      setImageSelected(UploadATDBg);
      setBgSize('cover');
    } else if (path.currentPath === '/upload-finance') {
      setTitle(newObj.FinanceWord[language]);
      setImageSelected(UploadKewanganBg);
      setBgSize('cover');
    } else if (path.currentPath === '/upload-documentation') {
      setTitle(newObj.DocumentationWord[language]);
      setImageSelected(UploadDocumentationBg);
      setBgSize('cover');
    }
  }, [path.currentPath, language]);

  const handleRenderDropzone = (path) => {
    switch (path) {
      case '/upload-documentation':
        return (
          <>
            <Box
              sx={{
                background: '#2B5180',
              }}
              className='boxUploadPage'
            >
              <Stepper active={steps} type={path} totalSteps={totalSteps} />
              <DocumentationDropzone
                onChange={handleChange}
                sx={{
                  borderRadius: '5px',
                  height: '80%',
                  width: '100%',
                }}
              />
            </Box>
          </>
        );
      case '/upload-pengesyoran-baja':
        return (
          <>
            <Box
              sx={{
                background: '#2B5180',
              }}
              className='boxUploadPage'
            >
              <Stepper active={steps} type={path} totalSteps={totalSteps} />
              <PengesyoranBajaDropzone onChange={handleChange} />
            </Box>
          </>
        );
      case '/upload-atd':
        return (
          <>
            <Box
              sx={{
                background: '#2B5180',
                padding: steps >= 1 ? '' : '0px',
              }}
              className='boxUploadPage'
            >
              {steps >= 1 && (
                <Stepper active={steps} type={path} totalSteps={totalSteps} />
              )}
              <ATDDropzone onChange={handleChange} />
            </Box>
          </>
        );
      case '/upload-finance':
        return (
          <>
            <Box
              sx={{
                background: '#2B5180',
                padding: '20px 0 0',
              }}
              className='boxUploadPage'
            >
              <Stepper active={steps} type={path} totalSteps={totalSteps} />
              <FinanceDropzone onChange={handleChange} />
            </Box>
          </>
        );
      default:
        return (
          <Box
            sx={{
              background: '#2B5180',
            }}
            className='boxUploadPage'
          >
            <Stepper active={steps} type={path} totalSteps={totalSteps} />
            <MyDropzone
              onChange={handleChange}
              sx={{
                borderRadius: '5px',
                height: '80%',
                width: '100%',
              }}
            />
          </Box>
        );
    }
  };

  const handleChange = (newValue) => {
    setSteps(newValue);
  };

  const isXsScreen = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
  const isSmScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          backgroundImage: `url(${macWP})`,
          backgroundRepeat: 'no-repeat',
          backgroundColor: (t) =>
            t.palette.mode === 'light'
              ? t.palette.grey[50]
              : t.palette.grey[900],
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          paddingTop: isSmScreen || isXsScreen ? '10px' : '20px',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <PageNav title={title} href='/adminpage' />
        <Grid
          component='main'
          rowSpacing={1}
          columnSpacing={{xs: 1, sm: 2, md: 3}}
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'center',
            padding: '10px',
          }}
        >
          <Box
            sx={{
              background: '#EFEFEF',
              backgroundImage: `url(${imageSelected})`,
              borderRadius: '10px',
              backgroundRepeat: 'no-repeat',
              backgroundSize: `${bgSize}`,
              backgroundPosition: 'left',
            }}
            className={'boxContainer'}
          >
            {handleRenderDropzone(path.currentPath)}
          </Box>
        </Grid>
      </Box>
    </ThemeProvider>
  );
};

export default UploadPage;
